<template>
  <div ref="DigiAssessmentView" id="DigiAssessmentView">
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" :viewOnly="viewOnly" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :viewOnly="viewOnly" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :info="taskResults" :newScore="quizAchievedMarks" :freeTextTotal="quizTotalMarks" :viewOnly="viewOnly" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question :isCardActive="tableQuestion" :question="taskResults" :answer="answer" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" :viewOnly="viewOnly" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- Upload -->
          <upload-question :isCardActive="uploadQuestion" :question="taskResults" :answer="answer" :viewOnly=" viewOnly === 'true'" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view :isCardActive="uploadTaskView" :uploadTask="taskResults" @loadTask="loadTask" :viewOnly="viewOnly" @initValues="initValues" />
    </div>
    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view :isCardActive="captureTaskView" :captureTask="taskResults" :viewOnly="viewOnly" />
    </div>

    <vx-card v-if="taskResults && taskResults.uploadTaskId && (taskResults.teacherFeedbackDocumentUrls.length != 0)" class="mt-3 mb-4">

      <vs-table ref="uploadsTable" single :data="taskResults.teacherFeedbackDocumentUrls" >
        <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center">
            <h5>Additional Uploads</h5>
          </div>
        </div>

        <template slot-scope="{data}">
          <vs-tr :data="taskResults.teacherFeedbackDocumentUrls" :key="indextr" v-for="(file, indextr) in data">
            <vs-td>
              <img :src="setFileThumb(file)" width=30px class="product-img" />
            </vs-td>
            <vs-td>
              <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
            </vs-td>
            <vs-td>
              <vs-button color="success" class="float-right" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      
      </vs-table>
    </vx-card>

    <div>
      <ispring-final-comment-view v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId" :isCardActive="ispringFinalCommentView && !(loadingView || errorLoadingView)" :totalScore="ispringTotalScore" :quizData="taskResults" :viewOnly="viewOnly" />
      <quiz-final-comment-view v-else-if="taskResults && taskResults.quizId" :isCardActive="quizFinalCommentView && !(loadingView || errorLoadingView)" :quizAchievedMarks="quizAchievedMarks" :quizInfo="taskResults" :quizTextTotal="quizTotalMarks" :viewOnly="viewOnly" />
      <upload-comment-view v-else-if="taskResults && taskResults.uploadTaskId" :isCardActive="uploadCommentView && !(loadingView || errorLoadingView)" :uploadTask="taskResults" :viewOnly="viewOnly" />
      <capture-comment-view v-else-if="taskResults && taskResults.videoCaptureTaskId" :isCardActive="captureCommentView && !(loadingView || errorLoadingView)" :captureTask="taskResults" :viewOnly="viewOnly" />
    </div>

    <vs-popup id="cellViewPopup" title="Confirm" :active.sync="rejectPopupConfirm">
      <div class="mt-3">
        By choosing 'Reject & Query', the assessment and any comments you made will be reviewed by an Assessor. Feedback will be given to you as soon as possible.
        <div class="float-right mt-5">
            <vs-button color="warning" @click="queryAssessment">OK</vs-button>
            <vs-button color="warning" class="ml-1" @click="rejectPopupConfirm = false">Cancel</vs-button>          
        </div>
      </div>
    </vs-popup>

    <vs-popup id="cellViewPopup" title="Confirm" :active.sync="confirmPopupConfirm">
      <div class="mt-3">
        By choosing 'Accept', you agree with the final results of this assessment and that any of the comments you made will be disregarded.
        <div class="float-right mt-5">
            <vs-button color="warning" @click="acceptAssessment">OK</vs-button>
            <vs-button color="warning" class="ml-1" @click="confirmPopupConfirm = false">Cancel</vs-button>          
        </div>
      </div>
    </vs-popup>

    <div v-if="taskResults.length != 0" class="vx-row">
      <vs-spacer></vs-spacer>
      <div id="buttons-container" class="vx-col">
        <vs-button v-if="!viewOnly" color="success" class="mr-2 vs-con-loading__container" ref="acceptButton" @click="confirmAccept">Accept</vs-button>
        <vs-button v-if="!viewOnly" color="danger" class="mr-6 vs-con-loading__container" ref="queryButton" @click="confirmQuery">Reject & Query</vs-button>
        <vs-button v-if="viewOnly && taskResults.statusId == 1 && taskResults.uploadTaskId" color="danger" class="mr-2 mb-2" @click="discardTaskPopup(false)">Discard</vs-button>
        <vs-button v-if="viewOnly && taskResults.statusId == 1 && taskResults.uploadTaskId" color="warning" class="mr-2 mb-2" @click="discardTaskPopup(true)">Discard & Redo</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeTab">{{ viewOnly ? 'Close' : 'Cancel' }}</vs-button>
      </div>
    </div>

    <vs-popup id="cellViewPopup" title="Confirm" :active.sync="discardTaskPopupItem">
      <div class="mt-3">
        {{discardTaskPopupText}}
        <div class="float-right mt-5">
            <vs-button color="success" @click="discardTask">Okay</vs-button>
            <vs-button color="warning" class="ml-1" @click="discardTaskPopup = false">Cancel</vs-button>          
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import ispringQuizInfoView from "@/digicampus/assessedviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "@/digicampus/assessedviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "@/digicampus/assessedviews/MultipleResponseQuestion.vue";
import textQuestion from "@/digicampus/assessedviews/TextQuestion.vue";
import sequenceQuestion from "@/digicampus/assessedviews/SequenceQuestion.vue";
import matchingQuestion from "@/digicampus/assessedviews/MatchingQuestion.vue";
import sentenceQuestion from "@/digicampus/assessedviews/SentenceQuestion.vue";
import quizInfoView from "@/digicampus/assessedviews/QuizInfoView.vue";
import mcssQuestion from "@/digicampus/assessedviews/MCSSQuestion.vue";
import mcmsQuestion from "@/digicampus/assessedviews/MCMSQuestion.vue";
import dragAndDrop from "@/digicampus/assessedviews/DragAndDrop.vue";
import freeTextQuestion from "@/digicampus/assessedviews/FreeTextQuestion.vue";
import uploadQuestion from "@/digicampus/assessedviews/UploadQuestion.vue";
import tableQuestion from "@/digicampus/assessedviews/TableQuestion.vue";
import uploadTaskView from "@/digicampus/assessedviews/UploadTaskView.vue";
import captureTaskView from "@/digicampus/assessedviews/CaptureTaskView.vue";
import loadingView from "@/digicampus/assessedviews/ResultsLoadingView.vue";
import errorLoadingView from "@/digicampus/assessedviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "@/digicampus/assessedviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "@/digicampus/assessedviews/QuizFinalCommentView.vue";
import uploadCommentView from "@/digicampus/assessedviews/UploadCommentView.vue";
import captureCommentView from "@/digicampus/assessedviews/CaptureCommentView.vue";

export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    quizInfoView,
    mcssQuestion,
    mcmsQuestion,
    freeTextQuestion,
    tableQuestion,
    dragAndDrop,
    uploadTaskView,
    captureTaskView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView,
    uploadQuestion
  },
  data() {
    return {
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      tableQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      statusId: 0,
      viewOnly: false,
      uploadedFileUrlList: [],
      rejectPopupConfirm: false,
      confirmPopupConfirm: false,
      dragAndDropQuestion: true,
      discardTaskPopupItem:false,
      discardTaskPopupText:"",
      redoTask:false,
      uploadQuestion:true,
    };
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;
        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      window.open("", "_self").close();
    },
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadTask() {
      const self = this;
      self.loadingView = true;

      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
          self.taskResults.newUploadedFiles = [];

          self.uploadedFileUrlList = self.taskResults.teacherFeedbackDocumentUrls;
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };

      self.$ajaxGet(self, "student/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    saveChanges() {

      var self = this;
      if (self.statusId == 5)
        self.showLoadingOnElement("queryButton", 0.45, "material");
      else if (self.statusId == 6)
        self.showLoadingOnElement("acceptButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.acceptButton.$el);
        self.$vs.loading.close(self.$refs.queryButton.$el);
        self.closeTab();
      };

      var assessmentReview = {};
      assessmentReview.logId = self.$route.query.TaskLogId;
      assessmentReview.statusId = self.statusId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentReview.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/SaveStudentReview", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentReview.quizId = self.taskResults.quizId;
        assessmentReview.quizAnswers = self.taskResults.answers;
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "QuizAssessment/SaveStudentReview", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;
        assessmentReview.uploadTaskNewLogDTO = {
          logId: assessmentReview.logId,
          newUploadedFiles: self.taskResults.newFiles
        }

        self.$ajaxPost(self, "UploadAssessment/SaveStudentReview", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

          assessmentReview.NewFileTaskLogDTO = {
          logId: assessmentReview.logId,
          NewVideoCaptureTaskFiles: self.taskResults.newUploadedFiles        
      }
        self.$ajaxPost(self, "CaptureAssessment/SaveStudentReview", assessmentReview, onSuccess);
      }
    },
    acceptAssessment(){
      var self = this;

      self.showLoadingOnElement("acceptButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.acceptButton.$el);
        self.closeTab();
      };

      var assessmentReview = {};
      assessmentReview.logId = self.$route.query.TaskLogId;
      assessmentReview.statusId = self.statusId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentReview.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentReview.quizId = self.taskResults.quizId;
        assessmentReview.quizAnswers = self.taskResults.answers;
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "QuizAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        self.$ajaxPost(self, "UploadAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        self.$ajaxPost(self, "CaptureAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
    },
    queryAssessment(){
      var self = this;

      self.showLoadingOnElement("queryButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.queryButton.$el);
        self.closeTab();
      };

      var assessmentReview = {};
      assessmentReview.logId = self.$route.query.TaskLogId;
      assessmentReview.statusId = self.statusId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentReview.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentReview.quizId = self.taskResults.quizId;
        assessmentReview.quizAnswers = self.taskResults.answers;
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "QuizAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

          assessmentReview.NewFileTaskLogDTO = {
          logId: assessmentReview.logId,
          NewUploadedFiles: self.taskResults.newUploadedFiles
        }

        self.$ajaxPost(self, "UploadAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

          assessmentReview.NewFileTaskLogDTO = {
          logId: assessmentReview.logId,
          NewUploadedFiles: self.taskResults.newUploadedFiles        
        }
        self.$ajaxPost(self, "CaptureAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
    },
    confirmAccept(){
      var self = this;
      self.statusId = 6;
      self.confirmPopupConfirm = true;
    },
    confirmQuery(){
      var self = this;
      self.statusId = 5;
      self.rejectPopupConfirm = true;
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    downloadFile(file){
      window.open(file);
    },
    setFileThumb(url) {
      var ext = url.substring(url.lastIndexOf('.') + 1);
      if (ext.includes('mp3'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
      else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
      else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
      else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
    },
    discardTaskPopup(redo){
      var self = this;
      self.redoTask = redo;
      self.discardTaskPopupText = redo? "You are about to redo this task are you sure you want to redo this task":"You are about to discard this task. You won't be able to undo this change. This task will be removed";
      self.discardTaskPopupItem = true;
    },
    discardTask(){
      var self = this;
      self.showLoadingOnElement("DigiAssessmentView",1,"corners");
      var onSuccess = response =>{
        self.discardTaskPopupItem = false;
        if(self.redoTask){
          this.$router.push({
            name: "UploadViewer",
            query:{"id":self.taskResults.uploadTaskId,"redo":true}
          });
        }
        else{
          self.closeTab();
        }
      }
    
      var onFinally = response =>{
        if(self.$refs.DigiAssessmentView){
          self.$vs.loading.close(self.$refs.DigiAssessmentView.$el);
        }
      }
      self.$ajaxGet(self, "CourseTaskLog/DiscardTask?taskLogId="+ self.$route.query.TaskLogId , onSuccess, onFinally);
    },
  },
  mounted() {
    var self = this;
    self.loadTask();
    self.isMounted = true;
    self.viewOnly = self.$route.query.viewonly;
  }
}
</script>
<style>
@media screen and (max-width: 644px) {
  #buttons-container {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}

#downloadbutton{
  border-radius: 10px 10px 10px 10px
}
</style>
